import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Col,
    Container,
    Table
} from "reactstrap";



const LogsWIP = () => {
    const [logsData, setLogsData] = useState([]);

    const fetchLogs = async () => {
        try {
            const res = await axios.get("/api/vr/logs", { withCredentials: true });
            setLogsData(Array.isArray(res) ? res : []);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        fetchLogs();
    }, []);


    const formatDateEU = (timestamp) => {
        if (!timestamp) return "-";


        let ts = timestamp;

        // 🔧 si timestamp en secondes → convertir en ms
        if (ts < 1e12) {
            ts = ts * 1000;
        }

        return new Intl.DateTimeFormat("fr-FR", {
            timeZone: "Europe/Paris",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        }).format(new Date(timestamp));
    };


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Col lg={12}>
                        <div className="card">
                            <div className="card-body">
                                <h4 className="card-title mb-4">Logs WIP</h4>
                                <div>
                                    <Table className="align-middle mb-0 table-nowrap">
                                        <thead className="table-light">
                                            <tr>
                                                <th>ID</th>
                                                <th>Content Version</th>
                                                <th>Date et heure</th>
                                                <th>User ID</th>
                                                <th>App Version</th>
                                                <th>Course Title</th>
                                                <th>Timer</th>
                                                <th>Chapter</th>
                                                <th>Headset ID</th>
                                                <th>Score</th>
                                                <th>Language</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {logsData.map((log) => (
                                                <tr key={log.logs_ID}>
                                                    <td>{log.logs_ID}</td>
                                                    <td>{log.logs_CONTENT_VERSION}</td>
                                                    <td>{formatDateEU(log.logs_TIMESTAMP * 1000)}</td>
                                                    <td>{log.logs_USER_ID}</td>
                                                    <td>{log.logs_APP_VERSION}</td>
                                                    <td>{log.logs_COURSE_TITLE}</td>
                                                    <td>{log.logs_TIMER}</td>
                                                    <td>{log.logs_CHAPTER}</td>
                                                    <td>{log.logs_HEADSET_ID}</td>
                                                    <td>{log.logs_SCORE}</td>
                                                    <td>{log.logs_LANGUAGE}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default LogsWIP;

//Creators : Florian Cohen-Joly @3DDGAMES -- Under license